

import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { defineCommand } from '../../concepts/commands/CommandDefinition';
import { AppEvents } from '../AppEvents';
import { asyncOptionsPopupWith } from '../popups/OptionsPopup';
import { PopupManager } from '../popups/PopupManager';
import { manageUserRolePopup } from './ManageUserRolePopup';

export const userRemove = defineCommand(
    'userRemove',
    'Admin: User Remove',
    async (r, [userId]: [string]) => {

        if (!userId) return false;

        const api = r.call(ApiClient);
        const evts = r.call(AppEvents);

        const execute = () => api.exec(v2.admin.users.remove({ userId }));
        const popup = asyncOptionsPopupWith(
            'Remove User',
            'Please confirm you want to remove this user?  ' +
            'Their access will to the organization will be revoked and their personal workspace will be deleted.  ' +
            'Any boards no longer accessible will automatically be archived.',
            [
                ['Remove User', 'negative', execute],
            ]
        );

        const { actioned, data } = await r.call(PopupManager).invoke(popup);
        if (!actioned || !data) return false;

        evts.push('account:userLeave', { userId });
        return true;
    }
);

export const userChangeRole = defineCommand(
    'userChangeRole',
    'Admin: Change Role...',
    async (r, [userId, roleName]: [string, string?]) => {

        if (!userId) return false;

        const api = r.call(ApiClient);
        const evts = r.call(AppEvents);
        const popups = r.call(PopupManager);

        if (roleName) {
            await api.exec(v2.admin.users.setRole({ userId, roleName }));
            evts.push('account:setRole', { userId, roleName });
            return true;
        }
        else {
            await popups.invoke(manageUserRolePopup(userId));
        }

        // const execute = () => api.exec(v2.admin.users.setAdmin({ userId, value }));
        // const popup = asyncOptionsPopupWith(
        //     value ? 'Promote To Admin' : 'Revoke Admin',
        //     'Please confirm you want to change this users administrator status?  ' +
        //     'Admins can access all workspaces and boards as well as promote or revoke admin priviledges from other users.',
        //     [
        //         value ? ['Promote', 'positive', execute] : ['Revoke', 'negative', execute],
        //     ]
        // );

        // const { actioned, data } = await r.call(PopupManager).invoke(popup);
        // if (!actioned || !data) return false;

        // evts.push('account:setAdmin', { userId, value });
        return true;
    }
);
